<p>
  default-package-page-template works!
</p>
